import { useState } from 'react';
import { useFedContent } from '../content';
import { Ic } from '../icons';
import DocumentViewer from './DocumentViewer';

export default function TournamentRegulation({ tournament, lang }) {
  const docs = useFedContent((s) => s.docs);
  const [open, setOpen] = useState(false);
  const doc = docs.find((item) => item.id === tournament.regulationDocId);
  if (!doc?.file) return null;
  const kz = lang === 'kz';
  return <>
    <div className="fed-regulation-card">
      <Ic name="doc" size={26} />
      <div><h3>{kz ? 'Турнир регламенті' : 'Регламент турнира'}</h3><p>{kz ? 'Толық ережелер, кесте және жүлде қоры. PDF-ті сайтта оқыңыз.' : 'Полные правила, расписание и призовой фонд. Читайте PDF прямо на сайте.'}</p></div>
      <button type="button" onClick={() => setOpen(true)}><Ic name="doc" size={18} />{kz ? 'Регламентті оқу' : 'Читать регламент'}</button>
    </div>
    {open && <DocumentViewer doc={doc} lang={lang} onClose={() => setOpen(false)} />}
  </>;
}
